/**
 * Set up a promise for when the page is first made visible for prerendering speculation rule
 * Documentation link: https://developer.chrome.com/docs/web-platform/prerender-pages#impact-on-analytics
 * example usage:
  async function initAnalytics() {
    await whenFirstVisible();
    // Initialise your analytics
  }

  initAnalytics();
 */
export const whenFirstVisible = () => new Promise((resolve) => {
  try {
    if (document.hidden) {
      document.addEventListener("visibilitychange", () => resolve(true), { once: true });
    } else {
      resolve(true);
    }
  } catch (error) {
    resolve(true);
  }
});

/**
 * Set up a promise for when the page is activated,which is needed for prerendered pages.
 * * Documentation link: https://developer.chrome.com/docs/web-platform/prerender-pages#impact-on-analytics
 * example usage:
  async function initAnalytics() {
    await whenActivated;
    // Initialise your analytics
  }

  initAnalytics();
 */
export const whenActivated = new Promise((resolve) => {
  try {
    if ((document as any).prerendering) {
      document.addEventListener("prerenderingchange", () => resolve(true), { once: true });
    } else {
      resolve(true);
    }
  } catch (error) {
    resolve(true);
  }
});

/**
 * Function to identify if the page is prerendered or rendered normally
 */
export const isPagePrerendered = (): boolean => {
  try {
    return (
      (document as any).prerendering ||
      (self.performance?.getEntriesByType?.("navigation") as any)[0]?.activationStart > 0
    );
  } catch (error) {
    return false;
  }
};

